import { useExperimentActivation } from '@/components/shared/ABTest'
import useApplicantQuery from '@/queries/use-applicant-query'
import useVerificationStatusQuery from '@/queries/use-verification-status-query'
import { CountryCodes } from '@/utils/language'

/**
 * 본인인증 플로우 로직을 관리하는 훅
 * AB테스트, 사용자 국적, 본인인증 상태에 따라 본인인증 여부를 판단
 */
export const useVerificationRequirement = () => {
  const { data: applicantData } = useApplicantQuery()
  const { data: verificationStatusData } = useVerificationStatusQuery()
  const { isActivated: isNewConsultationEnabled } = useExperimentActivation({
    experimentKey: 'ab_20251129_identity_verification',
    flag: 'A',
  })

  const shouldVerify = isNewConsultationEnabled && applicantData?.country === CountryCodes.KR
  const isVerified = verificationStatusData?.identityVerified ?? false

  return {
    /** 본인인증이 필요한 플로우인지 여부 */
    shouldVerify,
    /** 본인인증 완료 여부 */
    isVerified,
    /** 본인인증이 필요하지만 아직 완료하지 않은 상태 */
    needsVerification: shouldVerify && !isVerified,
    /** AB 테스트 그룹 */
    abTestGroup: isNewConsultationEnabled ? 'A' : 'CONTROL',
  }
}
